import React from "react";
import "./Codes.css";
import SamaListView from "../SamaListView";
import Button from "../Button";
import Input from "../InputText";
import DropList from "../DropList";
import ProgressBar from "react-bootstrap/ProgressBar";
import ActivityCodeList4 from "./index4-rule";

function defaultClick(e) {
  e.preventDefault();
}

function ActivityCodeList5(props) {
  let {
    Items,
    addNewCode,
    inputStyle,
    listName,
    onSelect,
    section,
    BtnActive_search,
    attributes,
    suggestions,
    onChange,
    onClick,
    userInputActivity_search,
    activeSuggestion,
    filteredSuggestionsActivity_search,
    showActivitySuggestions_search,
    handleItemDeletion,
    ActivityNow_Search,
    name,
    index,
  } = props;

  let Options;

  let suggestionsListComponentDiagnosis;

  if (showActivitySuggestions_search && userInputActivity_search) {
    if (
      filteredSuggestionsActivity_search &&
      filteredSuggestionsActivity_search.length
    ) {
      suggestionsListComponentDiagnosis = (
        <ul className="suggestions">
          {filteredSuggestionsActivity_search.map((suggestion, index) => {
            let className;

            // Flag the active suggestion with a class
            if (index === activeSuggestion) {
              className = "suggestion-active";
            }

            return (
              <li className={className} key={suggestion} onClick={onClick}>
                {suggestion}
              </li>
            );
          })}
        </ul>
      );
    } else {
      suggestionsListComponentDiagnosis = (
        <div className="no-suggestions">
          <em>No suggestions...</em>
        </div>
      );
    }
  }

  let InputId = "",
    BtnValue = "";
  if (listName === "ActivityCodes1") {
    InputId = "ActivityCodes1";
    BtnValue = "Confirm Code";
  }

  console.log("ActivityNow_Search");
  console.log(ActivityNow_Search);

  console.log("suggestions");
  console.log(suggestions);
  return (
    <React.Fragment>
      {Items && Items.length > 0 ? (
        <SamaListView
          Items={Items}
          name="codes"
          handleItemDeletion={handleItemDeletion}
          listName={listName}
        />
      ) : null}

      {!(ActivityNow_Search === 100 && suggestions) ? (
        <ProgressBar
          style={{ width: "70%", margin: "25px auto" }}
          animated
          variant="success"
          now={ActivityNow_Search}
        />
      ) : null}

      <Input
        id={InputId}
        disabled={suggestions === undefined ? true : false}
        Style={inputStyle}
        onChange={(e) => onChange(e, listName)}
        hint="Search For Activity code"
        value={listName === "ActivityCodes1" ? userInputActivity_search : null}
      />

      {listName === "ActivityCodes1" ? suggestionsListComponentDiagnosis : null}

      {listName === "ActivityCodes1" &&
      section === "activities" &&
      BtnActive_search ? (
        <React.Fragment>
          {attributes && attributes.length > 0
            ? attributes.map((attribute, index) => (
                <DropList
                  key={index}
                  id="diagnosisType"
                  Title="activities Type"
                  name="DiagnosisType"
                  Options={Options}
                  Values={Options}
                  defaultValue={Options[0]}
                  onSelect={onSelect}
                  Style="requestSelect"
                />
              ))
            : null}
          <Button
            Style="enabledStyle"
            Value={BtnValue}
            onClick={(e) => addNewCode(e, listName, InputId)}
          />
        </React.Fragment>
      ) : null}
    </React.Fragment>
  );
}
export default ActivityCodeList5;
